import { render, staticRenderFns } from "./OrdenesServicio.vue?vue&type=template&id=57c43660&"
import script from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
export * from "./OrdenesServicio.vue?vue&type=script&lang=ts&"
import style0 from "./OrdenesServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('57c43660', component.options)
    } else {
      api.reload('57c43660', component.options)
    }
    module.hot.accept("./OrdenesServicio.vue?vue&type=template&id=57c43660&", function () {
      api.rerender('57c43660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasCrm/OrdenesServicio.vue"
export default component.exports